import React, { useState } from 'react'
import { Header, Button, Paragraph, ErrorMark, MortgageRegulationContacts } from "../../../components/RegularComponents";
import TopNavigationBar from "../../TopNavigationBar";
import * as CONST from "../../../app/constants";
import * as UTILS from "../../../app/utils";
import { push } from 'connected-react-router';
import { useDispatch, useSelector } from 'react-redux';
import { saveBusinessLicenceApplicationData } from '../../../redux/slice/businessLicenceApplicationSlice';
import { ERROR_STRING } from '../../../app/errors';
import './ConfirmPrincipalBrokerQualification.styles.scss'
import { mraPrincipalBrokerSelector } from '../../../redux/selector/mraPrincipalBrokerSelector';

export const ConfirmPrincipalBrokerQualification = (props) => {

    const { isModal = false, onEditSave = () => {} } = props;
    const { principalBrokerApplication } = useSelector(
        mraPrincipalBrokerSelector
    );

    const companyRjscDetails = principalBrokerApplication?.businessLicenceData?.companyRjscDetails
    const {legalName, operatingName} = UTILS.decideLegalAndOperatingNames(companyRjscDetails)

    //const businessName = principalBrokerApplication?.name ?? ""

    const [applicationSaveError, setApplicationSaveError] = useState(false);
    const [notQualified, setNotQualified] = useState(false);
    const dispatch = useDispatch();
    
    const handleContinue = () => {
        
        setApplicationSaveError(false);

        dispatch(saveBusinessLicenceApplicationData(CONST.APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE, CONST.APPLICATION_MODE_RENEW, false, "UPDATE"))
        .then(data => {
            if(isModal) {
                onEditSave()
            } else {
                dispatch(
                    push(`${CONST.ROUTE_PATH.MRA_APP}${CONST.ROUTE_PATH.MRA_RENEWAL_BROKER_CRIMINAL_RECORD_CHECK}`)
                );
            }
        })
        .catch(err => {
            setApplicationSaveError(true)
        })
    }

    const handleCancel = () => {
        setNotQualified(true);
    }

    return (
        <div className={!isModal ? "container" : ""}>
            {!isModal && <TopNavigationBar {...props} />}
            
            <div className="row">
                {!isModal &&
                <div className="col-xs-12 col-lg-11">
                    <Header
                        id="mra-renewal-confirm-air-header"
                        header="Principal Broker Qualifications"
                    />
                </div>
                }
                <div className="col-xs-12 col-lg-11 topMarginMedium">
                    <Paragraph
                        id="mra-renewal-confirm-air-text-1"
                        style={{fontWeight: "bold", fontSize: "1.2em"}}
                        text={[
                            `Please review the following requirements`,
                        ]}
                    />
                </div>
            </div>
            
            <div className={"row"}>
                <div className={"col-8"}>
                    <ol className="principalBrokerQualificationReqList">
                        <li>
                            Are you authorised to carry out the duties and responsibilities of a principal broker on behalf of the mortgage brokerage?
                        </li>
                        <li>
                            Depending on the type of the company , the Principal Broker must meet certain requirements (confirmed by RJSC).
                            <ul>
                                <li>
                                    <b>Corporation</b> - you must be an officer/director.
                                </li>
                                <li>
                                    <div><b>Partnerships</b> - for partnerships, the individual is a partner.</div>
                                    <div><b>Limited Partnerships</b> - individual is general partner or is a director or officer of a corporation that is a general partner.</div>
                                </li>
                                <li>
                                    <b>Sole proprietorships</b> - the individual is a sole proprietor.
                                </li>
                            </ul>
                        </li>
                        <li>
                            {(operatingName && legalName) && 
                                <>
                                    Are you still the Principal Broker for <b>{`${operatingName}(${legalName})`}</b>?
                                </>
                            }
                            {operatingName && 
                                <>Are you still the Principal Broker for <b>{`${operatingName}`}</b>?</>
                            }
                            {legalName && 
                                <>Are you still the Principal Broker for <b>{`${legalName}`}</b>?</>
                            }
                            {(!operatingName && !legalName) && 
                                <>
                                    Are you still the Principal Broker?
                                </>
                            }
                        </li>
                    </ol>
                </div>

                <div className={"col-8 topMarginMedium"}>
                    <b>Do you meet these requirements?</b>
                </div>
            </div>

            <div className="row topMarginMedium">
                <div className="col-lg-8">
                    <div className="col-xs-2">
                        <Button
                            className="btn-lg btn-default"
                            buttonType={"regular_primary"}
                            text={!isModal ? "Yes" : "Save and close"}
                            onClick={handleContinue}
                        />
                        {(applicationSaveError)  && ErrorMark()}
                        {applicationSaveError && (
                        <div className="ns-error-message">
                            <span className="ns-visually-hidden">Error:</span>
                            {ERROR_STRING.APPLICATION_SAVE_ERROR}
                        </div>
                        )}
                    </div>
                    <div className="col-xs-6">
                        <Button
                            className="btn-lg btn-default"
                            buttonType={"regular_primary"}
                            text={"No"}
                            onClick={handleCancel}
                        />
                        {notQualified  && ErrorMark()}
                        {notQualified && 
                            <MortgageRegulationContacts message="If you do not meet the qualifications you must assign
                            a different Principal Broker who meets the qualifications.
                            To assign a different Principal Broker, contact Business Licensing:" 
                            />
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}
